<template>
  <div style="height:100%">
    <zkThreeRow>
      <div slot="search" class="company_cla">
        <el-form :model="searchForm" :inline="true">
          <el-form-item label="">
            <el-select v-model="searchForm.type" clearable>
              <el-option
                v-for="(item, index) in selectOptions"
                :key="index"
                :label="item.label"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="searchForm.value"
              :placeholder="this.$t('common.searchValue')"
              clearable
            >
              <el-button
                slot="append"
                @click.stop="searchFn"
                icon="el-icon-search"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <ZkButtonGroup
          :isLoadGroupName="true"
          @addCompany="addCompany"
          groupName="addCompany"
          :isGroup="true"
        ></ZkButtonGroup>
      </div>
      <div slot="table" class="">
        <companyList
          @selectRow="selectRow"
          ref="companyList"
          @searchFn="searchFn"
        ></companyList>
      </div>
    </zkThreeRow>

    <el-dialog
      :title="this.$t('header.createCompany')"
      :visible.sync="addComVisible"
      width="45%"
      @close="handleAddClose"
      append-to-body
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="createForm"
        label-width="180px"
      >
        <template v-if="!createCmpSuccess">
          <el-form-item :label="this.$t('developer.name')" prop="appKey">
            <el-select v-model="ruleForm.appKey" style="width:100%">
              <el-option
                v-for="item in options"
                :key="item.appKey"
                :label="item.name"
                :value="item.appKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="this.$t('header.companyCode')"
            prop="companyCode"
          >
            <el-input v-model.trim="ruleForm.companyCode"></el-input>
          </el-form-item>
          <el-form-item
            :label="this.$t('header.companyName')"
            prop="companyName"
          >
            <el-input v-model.trim="ruleForm.companyName"></el-input>
          </el-form-item>
          <el-form-item :label="this.$t('user.email')" prop="email">
            <el-input v-model.trim="ruleForm.email"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <p>{{ $t('developer.createAppSucess') }}</p>

          <el-row :gutter="10" style="margin:5px 0">
            <el-col :span="4">{{ $t('apiLog.companyUser') }}：</el-col>
            <el-col :span="12">
              <div style="display:flex;align-items: center;">
                <el-input v-model="apiUser.userName" disabled></el-input>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('company.apiUserTips')"
                  placement="bottom"
                >
                  <i class="el-icon-info" style="margin:0 15px"></i>
                </el-tooltip>
                <el-button
                  type="text"
                  style="color:#4db22f"
                  class="logocontent"
                  :data-clipboard-text="apiUser.userName"
                  @click="copy('.logocontent')"
                >
                  {{ $t('apiLog.copy') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="margin:5px 0">
            <el-col :span="4">{{ $t('login.password') }}：</el-col>
            <el-col :span="12">
              <div style="display:flex;align-items: center;">
                <el-input
                  v-model="apiUser.password"
                  :disabled="true"
                ></el-input>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('company.loginUserTips')"
                  placement="bottom"
                >
                  <i class="el-icon-info" style="margin:0 15px"></i>
                </el-tooltip>
                <el-button
                  type="text"
                  style="color:#4db22f"
                  class="logocontent"
                  :data-clipboard-text="apiUser.password"
                  @click="copy('.logocontent')"
                >
                  {{ $t('apiLog.copy') }}
                </el-button>
              </div>
              <div>此密码只显示一次，请记住密码</div>
            </el-col>
          </el-row>
          <template v-if="companyManagerOn">
            <el-row :gutter="10" style="margin:5px 0">
              <el-col :span="4">{{ $t('user.accountByLogin') }}：</el-col>
              <el-col :span="12">
                <div style="display:flex;align-items:center">
                  <el-input v-model="superUser.userName" disabled></el-input>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="企业管理员登录该平台的账号"
                    placement="bottom"
                  >
                    <i class="el-icon-info" style="margin:0 15px"></i>
                  </el-tooltip>
                  <el-button
                    type="text"
                    style="color:#4db22f"
                    class="logocontent"
                    :data-clipboard-text="superUser.userName"
                    @click="copy('.logocontent')"
                  >
                    {{ $t('apiLog.copy') }}
                  </el-button>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="margin:5px 0">
              <el-col :span="4">{{ $t('login.password') }}：</el-col>
              <el-col :span="12">
                <div style="display:flex;align-items:center">
                  <el-input v-model="superUser.password" disabled></el-input>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="企业管理员登录该平台的密码"
                    placement="bottom"
                  >
                    <i class="el-icon-info" style="margin:0 15px"></i>
                  </el-tooltip>
                  <el-button
                    type="text"
                    style="color:#4db22f"
                    class="logocontent"
                    :data-clipboard-text="superUser.password"
                    @click="copy('.logocontent')"
                  >
                    {{ $t('apiLog.copy') }}
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </template>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleAddClose">{{
          createCmpSuccess ? $t('developer.isOk') : $t('common.cancel')
        }}</el-button>
        <el-button type="primary" @click="sumbitAddCompany">
          {{
            createCmpSuccess ? $t('company.entryCompany') : $t('common.confirm')
          }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import companyList from './companyInfo/companyList'
import { createCompany, getAppCom } from '@/services/acountApi.js'
import { validatorEmailRule } from '@/utils/validatorRule.js'
import { Throttle } from '@/utils/debounceThrottle.js'
import Clipboard from 'clipboard'

export default {
  data() {
    return {
      myOptions: {
        labels: {
          buttonStop: this.$t('developer.isOk')
        }
      },
      steps: [
        {
          target: '.api_user_password',
          content: '请记住密码'
        }
      ],
      currentRow: null,
      addComVisible: false,
      ruleForm: {
        companyName: '',
        companyCode: '',
        appKey: '',
        email: ''
      },
      rules: {
        appKey: [
          {
            required: true,
            message: this.$t('companyList.selectApp'),
            trigger: 'blur'
          }
        ],
        companyName: this.validatorInputEmptyRule(true, 100),
        companyCode: this.validatorInputEmptyRule(true, 16),
        email: validatorEmailRule(true)
      },
      searchForm: {
        type: '',
        value: ''
      },
      selectOptions: [
        {
          key: 1,
          label: this.$t('company.name'),
          attr: 'companyName'
        },
        {
          key: 2,
          label: this.$t('company.code'),
          attr: 'companyCode'
        }
      ],
      options: [],
      appList: [],
      createCmpSuccess: false,
      apiUser: {},
      superUser: {},
      companyId: '',
      companyManagerOn: 0
    }
  },
  mounted() {
    getAppCom().then(data => {
      if (data.code === '00000000') {
        // 过滤 已下线的应用
        this.appList = data.payload.results.dbsAppInfoList
        this.options = data.payload.results.dbsAppInfoList.filter(item => {
          return item.active === true
        })
      } else {
        this.$message.error(data.message)
      }
    })
  },

  methods: {
    copy(select) {
      var clipboard = new Clipboard(select)
      clipboard.on('success', e => {
        this.$notify({
          title: this.$t('apiLog.success'),
          message: this.$t('apiLog.copySucess'),
          type: 'success'
        })
        clipboard.destroy() // 释放内存
      })
      clipboard.on('error', e => {
        this.$notify({
          title: this.$t('apiLog.fail'),
          message: this.$t('apiLog.copyError'),
          type: 'warning'
        })
        clipboard.destroy() // 释放内存
      })
    },
    searchFn() {
      let params = {}
      this.selectOptions.filter(item => {
        if (item.key === this.searchForm.type) {
          params[item.attr] = this.searchForm.value
        }
      })

      this.$refs.companyList.searchFn(params)
    },
    selectRow(row) {
      try {
        if (row !== null) {
          this.currentRow = row

          sessionStorage.setItem('currentRow', row.id)
        } else {
          sessionStorage.removeItem('currentRow')
          this.currentRow = null
        }
      } catch (e) {}
    },

    sumbitAddCompany: Throttle(function() {
      if (this.createCmpSuccess) {
        let companyDetail = {
          companyId: this.companyId,
          companyManagerOn: this.companyManagerOn
        }
        sessionStorage.setItem('companyDetail', JSON.stringify(companyDetail))
        this.$router.push({
          name: 'companyDetails'
        })
        return true
      }
      this.$refs.createForm.validate(valid => {
        if (valid) {
          createCompany(this.ruleForm)
            .then(data => {
              if (data.code === '00000000') {
                this.createCmpSuccess = true

                this.companyId = data.payload.results.companyId
                this.apiUser = data.payload.results.apiUser
                if (data.payload.results.superUser) {
                  this.companyManagerOn = 1
                  this.superUser = data.payload.results.superUser
                }
              } else {
                this.$message.error(data.message)
              }
            })
            .catch(e => {})
        }
      })
    }, 300),
    handleAddClose() {
      // this.$tours.myTour.stop()
      this.addComVisible = false

      this.ruleForm.companyName = ''
      this.ruleForm.companyCode = ''
      this.ruleForm.email = ''
      if (this.$refs.createForm) {
        this.$refs.createForm.resetFields()
      }
      this.$refs.companyList.commQuery()
      setTimeout(() => {
        this.createCmpSuccess = false
      }, 300)
    },
    addCompany() {
      try {
        // 目前 只有第三存在缓存appkey 其他角色没有 创建默认应用
        this.$root.appKey = sessionStorage.getItem('appKey')
        if (this.$root.appKey) {
          for (let i = 0; i < this.options.length; i++) {
            if (this.options[i].appKey === this.$root.appKey) {
              this.ruleForm.appKey = this.options[i].appKey
              return
            } else {
              this.ruleForm.appKey = this.options[0].appKey
            }
          }
        } else {
          this.ruleForm.appKey = this.options[0].appKey
        }
      } catch (err) {
      } finally {
        this.addComVisible = true
      }
    }
  },
  components: {
    companyList
    // VueTour
  }
}
</script>

<style scoped lang="less">
.company_cla {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/CompanyInfo.vue